<template>
  <v-card>
    <v-dialog
        v-model="jobSetAddDialog"
        width="700"
    >
      <v-card>
        <v-card-title>
          Добавление работ
        </v-card-title>
        <v-card-text>
          <v-text-field label="Поиск" v-model="search">
          </v-text-field>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Наименование
                </th>
                <th class="text-left">
                  Категория
                </th>
                <th class="text-left">
                  Цена
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in filteredJobs"
                  :key="item.id"
                  @click="addJobSetItem(item)"
                  style="cursor: pointer"
              >
                <td>{{ item.jobName }}</td>
                <td>{{ item.category?.name }}</td>
                <td>{{ item.price }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="jobSetAddDialog = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="sharePartAddDialog"
        width="80%"
    >
      <v-card>
        <v-card-title>
          Добавление запчастей и расходного материала
        </v-card-title>
        <v-card-text>
          <v-text-field label="Поиск" v-model="searchText" @input="searchShareParts">
          </v-text-field>
          <v-data-table
              :headers="headers"
              :items="data"
              :items-per-page="size"
              @click:row="addSharePartItem($event)"
              style="cursor: pointer"
              :server-items-length="totalElements"
              :options.sync="options"
              :multi-sort="false"
              class="elevation-1"
              :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
          >
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="sharePartAddDialog = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <v-btn @click="goBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
            Назад
          </v-btn>
        </v-col>
        <v-col cols="12">
          Создание заказ наряда
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="3">
          <v-switch
              v-model="userRegistered"
              :label="`Пользователь ${userRegistered === true ? 'зарегистрирован' : 'не зарегистрирован'}`"
          ></v-switch>
        </v-col>
      </v-row>
      <div v-if="userRegistered" class="d-flex justify-center align-center ml-2" style="width: 400px">
        <v-text-field
            v-model="searchUserText"
            label="Поиск пользователя по логину"
        />
        <v-btn
            :disabled="searchUserText.length < 3"
            @click="searchUser"
            color="primary"
            class="ml-2"
            type="submit"
        >
          Найти
        </v-btn>
      </div>
      <div v-if="userCars.length > 0">
        <v-radio-group v-model="userCarSelect">
          <v-radio
              v-for="item in userCars"
              :key="item.id"
              :label="`${item.carBrand.name + ' ' + item.carModel.name}`"
              :value="item"
          ></v-radio>
        </v-radio-group>
      </div>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col v-if="!userRegistered" cols="12" sm="3">
              <v-text-field
                  v-model="form.fullName"
                  label="ФИО"
              ></v-text-field>
            </v-col>
            <v-col v-if="!userRegistered" cols="12" sm="3">
              <v-select @change="selectCarBrand($event)" v-model="form.carBrandId" :items="carBrandList" item-text="name" item-value="id" label="Бренд авто" />
            </v-col>
            <v-col v-if="!userRegistered" cols="12" sm="3">
              <v-select v-model="form.carModelId" :items="carModelList" item-text="name" item-value="id" label="Модель авто" />
            </v-col>
            <v-col v-if="!userRegistered" cols="12" sm="3">
              <v-text-field
                  v-model="form.carStateNumber"
                  label="Гос. номер авто"
              ></v-text-field>
            </v-col>
            <v-col v-if="!userRegistered" cols="12" sm="3">
              <v-text-field
                  v-model="form.vinCode"
                  label="VIN код авто"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  type="number"
                  v-model="form.mileage"
                  label="Пробег"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                  ref="fromMenu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="form.checkInTime"
                      prepend-icon="mdi-calendar"
                      label="Дата заезда"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="form.checkInTime"
                    @input="menu1 = false"
                    locale="ru"
                ></v-date-picker>
              </v-menu>
            </v-col>

          </v-row>
          <div class="mt-4 d-flex align-center justify-start">
            <div style="width: 200px">
              Список выполненных работ
            </div>
            <v-btn @click="jobSetAddDialog = true" class="mx-4" small>
              Добавить
            </v-btn>
          </div>
          <v-simple-table v-if="jobSet.length > 0">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Наименование
                </th>
                <th class="text-left">
                  Кол-во
                </th>
                <th class="text-left">
                  Цена
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in jobSet"
                  :key="item.id"
              >
                <td>
                  <v-text-field
                    v-model="item.jobName"
                ></v-text-field>
                </td>
                <td>
                  <v-text-field
                      type="number"
                      v-model="item.amount"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                      type="number"
                      v-model="item.price"
                  ></v-text-field>
                </td>
                <td>
                  <v-icon
                      class="mr-2"
                      @click="deleteItem(item)"
                  >
                    mdi-close
                  </v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="mt-4 d-flex align-center justify-start ">
            <div style="width: 200px">
              Запчасти
            </div>
            <v-btn @click="sharePartAddDialog = true" class="mx-4" small>
              Добавить
            </v-btn>
          </div>
          <v-simple-table v-if="shareParts.length > 0">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Наименование
                </th>
                <th class="text-left">
                  Сокращенный код
                </th>
                <th class="text-left">
                  Кол-во
                </th>
                <th class="text-left">
                  Цена
                </th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in shareParts"
                  :key="item.id"
              >
                <td>
                  <v-text-field
                      v-model="item.name"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                      v-model="item.vendorCode"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                      type="number"
                      v-model="item.amount"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                      type="number"
                      v-model="item.price"
                  ></v-text-field>
                </td>
                <td>
                  <v-icon
                      class="mr-2"
                      @click="deleteSharePartItem(item)"
                  >
                    mdi-close
                  </v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </v-form>
      <v-btn @click="createPurchaseOrder" class="mt-4" color="primary">
        Добавить
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>

import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'PurchaseAdd',
  data () {
    return {
      userCarSelect: null,
      searchUserText: '',
      size: 10,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Наименование', value: 'name' },
        { text: 'Бренд', value: 'brandName' },
        { text: 'Артикул', value: 'vendorCode' },
        { text: 'Цена', value: 'price' },
        { text: 'Дилерская цена', value: 'dealerPrice' },
        { text: 'Количество', value: 'amount' },
        { text: 'Для продажи', value: 'isForSale' },
      ],
      jobSetAddDialog: false,
      jobSet: [
      ],
      form: {
        fullName: "",
        carModelId: null,
        carBrandId: null,
        carStateNumber: '',
        checkInTime: '',
        mileage: '',
        vinCode: ''
      },
      partnersCategoryJobs: [],
      search: '',
      searchText: '',
      shareParts: [],
      data: [],
      totalElements: 0,
      options: {},
      sharePartAddDialog: false,
      carBrandList: [],
      carModelList: [],
      menu1: false,
      valid: false,
      userRegistered: false,
      userCars: []
    }
  },
  mounted() {
    this.getPartnersCategoryJobs()
    this.getCarBrandList()
  },
  computed: {
    filteredJobs() {
      if (!this.search) return this.partnersCategoryJobs
      return this.partnersCategoryJobs.filter(item =>
          item.jobName.toLowerCase().includes(this.search.toLowerCase())
      )
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    createPurchaseOrder () {
      console.log('userCarSelect', this.userCarSelect)
      const data = JSON.parse(JSON.stringify(this.form))
      if (this.userRegistered) {
        data.notRegistered = false
        if (this.userCarSelect) {
          data.carBrandId = this.userCarSelect.carBrand.id
          data.carModelId = this.userCarSelect.carModel.id
          data.vincode = this.userCarSelect.vincode
          data.userCar = this.userCarSelect.id
        }
      } else {
        data.notRegistered = true
        data.userCar = null
      }
      if (this.userCarSelect) {
        data.carBrandId = this.userCarSelect.carBrand.id
        data.carModelId = this.userCarSelect.carModel.id
        data.vincode = this.userCarSelect.vincode
        data.userCar = this.userCarSelect.id
      }
      data.checkInTime = new Date(data.checkInTime)
      data.jobSet = this.jobSet.map(i => {
        i.jobId = i.id
        i.name = i.jobName
        return i
      })
      data.shareParts = this.shareParts.map(i => {
        i.sharePartId = i.id
        return i
      })
      console.log('data', data)
      this.$store.dispatch('partnerPurchaseOrder/createPurchaseOrder', data).then(() => {
        showSnackbar({
          message: "Заказ наряд успешно создана!",
          color: "success",
          timeout: 3000,
        })
      }).catch(() => {
        showSnackbar({
          message: "Не удалось создать заказ наряд!",
          color: "error",
          timeout: 3000,
        })
      })
    },

    searchUser() {
      console.log(this.searchUserText)
      this.$store.dispatch('userCar/getUserCarsByUsername', this.searchUserText).then(response => {
        this.userCars = response
      }).catch(error => {
        console.log(error)
        showSnackbar({
          message: "Не удалось найти пользователя!",
          color: "warning",
          timeout: 3000,
        })
      })
    },
    selectCarBrand (event) {
      this.$store.dispatch('carController/getCarModelListByBrandId', event).then((res) => {
        this.carModelList = res
      }).catch(err => {
        console.log(err)
      })
    },
    getCarBrandList () {
      this.$store.dispatch('carController/getCarBrandList').then((res) => {
        this.carBrandList = res
      }).catch(err => {
        console.log(err)
      })
    },
    addSharePartItem (event) {
      if (this.shareParts.filter(i => i.id === event.id).length > 0) {
        alert('Справочник уже добавлен')
        return
      }
      this.shareParts.push({
        name: event.sharePart.name,
        vendorCode: event.sharePart.vendorCode,
        price: event.price,
        id: event.id
      })
      this.sharePartAddDialog = false
    },
    searchShareParts () {
      this.getData()
    },
    async getData () {
      console.log('this.options', this.options)
      const sortBy = this.options.sortBy && this.options.sortBy.length > 0 ? this.options.sortBy[0] : ''
      const ascOrDesc = sortBy ? this.options.sortDesc.length > 0 ? (this.options.sortDesc[0] ? 'desc' : 'asc') : '' : ''
      const data = {
        size: this.options['itemsPerPage'],
        page: this.options['page'] - 1,
      }
      if (sortBy) {
        data.orderBy = sortBy
        data.ascOrDesc = ascOrDesc
      }
      if (this.searchText) {
        data.name = this.searchText
      }
      try {
        const resp = await this.$store.dispatch('partnerSpare/getPartnerSpares', data)
        this.data = resp.list.map((item) => {
          item.vendorCode = item.sharePart.vendorCode
          item.name = item.sharePart.name
          item.brandName = item.sharePart.brandName
          item.brandId = item.sharePart.brandId
          item.isForSale = item.isForSale ? 'Да' : 'Нет'
          item.isHidden = item.isHidden ? 'Да' : 'Нет'
          return item
        })
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    },
    async getPartnersCategoryJobs() {
      try {
        this.partnersCategoryJobs = await this.$store.dispatch('partnerDirectories/getPartnersCategoryJobs')
      } catch (e) {
        console.log('error', e)
      }
    },
    addJobSetItem (item) {
      if (this.jobSet.filter(i => i.id === item.id).length > 0) {
        alert('Справочник уже добавлен')
        return
      }
      this.jobSet.push({
        jobName: item.jobName,
        price: item.price,
        id: item.id
      })
      this.jobSetAddDialog = false
    },
    deleteSharePartItem (item) {
      this.shareParts = this.shareParts.filter(i => i.id !== item.id)
    },
    deleteItem (item) {
      this.jobSet = this.jobSet.filter(i => i.id !== item.id)
    },
    goBack () {
      this.$router.go(-1);
    },
  }
}
</script>
<style scoped>

</style>